import * as TSE from 'ts-events';
import { ObjectWithId } from './../../util/object-with-id';

export abstract class CommandExecutor extends ObjectWithId {
    public commandExecuted = new TSE.SyncEvent();
    public deleted = new TSE.SyncEvent();
    public reset = new TSE.SyncEvent();

    constructor() {
        super();
    }

    public requestExecute: any = (outputParameters: any) => {
        throw new Error('Not implemented requestExecute');
    }

    public requestReset: any = () => {
        throw new Error('Not implemented requestReset');
    }

    protected notifyExecute(outputParameters: any) {
        this.commandExecuted.post(outputParameters);
    }

    protected notifyDeleted() {
        this.deleted.post();
    }

    protected notifyReset(outputParameters: any) {
        this.reset.post(outputParameters);
    }
}
